/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// PROPERY EDITOR : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
    controls:{
        '& .newImageButtonContainer':{
            '& input[type=file]::-webkit-file-upload-button': {
                cursor: 'pointer'
                    },
            '& .newImageInput':{
                width: pxToEm(120),
                height: pxToEm(40),
                opacity: "0",
                overflow: 'hidden',
                position: 'absolute',
                zIndex: "1",
                cursor:'pointer'
            },
            '& .name-newImageButton':{
                pointerEvents:'none',
                height: pxToEm(30),
                marginBottom: pxToEm(5),
                marginLeft: pxToEm(5),
                fontSize: pxToEm(12)
            },
        },
        '& .slider':{
          width: '100%'
        },
        '& .actions': {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexDirection: 'row-reverse',
        },
        '& .name-submit': {
            width: pxToEm(80),
            height: pxToEm(30),
            fontSize: pxToEm(12)
        },
        '& .name-cancel': {
            width: pxToEm(80),
            height: pxToEm(30),
            marginLeft: pxToEm(10),
            marginRight: pxToEm(10),
            fontSize: pxToEm(12)
        }
    }
});